import { getHttp } from '@/api/httpFactory';
import { API_URLS } from './urls';

const http = getHttp(import.meta.env.VITE_API_BASE_URL);

const bankApi = {
    /**
     * Get a list of all banks
     * @param {*} payload
     */
    async fetchBanks() {
        const resp = await http.get(API_URLS.BANKS.GET);

        return resp.data;
    },

    async fetchAccount() {
        const resp = await http.get(API_URLS.BANKS.ACCOUNTS_SHOW);

        return resp.data;
    },
};

export default bankApi;
